import React, { useState, useEffect } from "react";

const LINKS = [
  { id: "day", label: "Our Day" },
  { id: "gallery", label: "Gallery" },
  { id: "rsvp", label: "RSVP" },
  { id: "stay", label: "Stay" },
  { id: "gifts", label: "Gifts" },
  { id: "dress", label: "Dress" },
];

const Nav = ({ active }) => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
  }, [open]);

  return (
    <nav className="nav" data-testid="main-nav">
      <div className="nav-inner">
        <a href="#top" onClick={scrollTo("top")} className="nav-monogram" aria-label="Top">
          R <span className="amp">&amp;</span> T
        </a>
        <button
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          data-testid="nav-toggle"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-links ${open ? "open" : ""}`}>
          {LINKS.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                onClick={scrollTo(l.id)}
                className={active === l.id ? "active" : ""}
                data-testid={`nav-link-${l.id}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
